// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fa68415d","455":"cef4c407"}[chunkId] + ".chunk.js";
};